exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expandable-panel[open] summary{padding:.75rem 0 1.75rem}.expandable-panel summary{font-size:14px;font-weight:500;line-height:24px;padding:.75rem 0;display:flex;align-items:center;justify-content:center;gap:1.625rem;cursor:pointer;list-style:none;user-select:none;color:var(--boy-blue)}.expandable-panel summary::before,.expandable-panel summary::after{content:\"\";flex:1;height:1px;background-color:var(--border)}", ""]);

// exports
